import { useState } from 'react';
import { listContacts } from 'services/Contact/contactServices';

// Custom sorting function
const sortContactsByType = (contacts) => {
  return contacts?.sort((a, b) => {
    const nameA = a?.first_name || a?.title || '';
    const nameB = b?.first_name || b?.title || '';

    // Convert to lowercase for case-insensitive comparison
    return nameA.toLowerCase().localeCompare(nameB.toLowerCase());
  });
};

export function useContacts(isLead = false, contactType = '') {
  const [results, setResults] = useState([]);
  const [loading, setLoading] = useState(false);

  const searchAsync = async (e) => {
    try {
      setLoading(true);
      const response = await listContacts({ contactType, keyWord: e?.query, pageLimit: 20, excludeFromLoading: true, in_lead: isLead });
      // Sort contacts alphabetically using custom sorting logic based on contact type
      const sortedContacts = response?.data?.contacts ? sortContactsByType(response.data.contacts) : [];
      setResults(sortedContacts);
      setLoading(false);
    } catch (error) {
      console.error('Error fetching data:', error);
      setLoading(false);
    }
  };

  return { contactList: results, searchAsync, loading };
}
